import { BaseMapper } from '@ps/utils';

import {
  BuyerAccessLevel,
  OperatorAccessLevel,
  SupplierAccessLevel,
} from '@ps/core-models';
import { SsoExchangeCodeResponseDto } from '../dtos/sso.dto';
import { User } from '../../models/user.model';

export class SsoMapper extends BaseMapper<SsoExchangeCodeResponseDto, User> {
  public fromDto(dto: SsoExchangeCodeResponseDto): User {
    const { user, token, churnZeroKey } = dto;

    return {
      id: user.id,
      accessLevel: user.accessLevel,
      address: user.addr,
      buyerAccessLevel: user.buyerAcssLvls as BuyerAccessLevel,
      churnZeroKey,
      companyId: user.cmp,
      createdOn: String(user.crtd_on),
      email: user.eml,
      hasConsolidatedView: user.consolidate_view,
      isApiUser: user.isApiUser,
      isBuyerUser: user.buyerUser,
      isSso: true,
      lastActiveTime: user.lastActiveTime,
      lastLoggedIn: user.lastLogin,
      modifiedOn: user.mod_on,
      operatorAccessLevel: user.operatorAcssLvls as OperatorAccessLevel,
      questionLibraryAccessLevel: user.questionLibraryAccessLevel,
      selectedDashboardView: user.selectedDashboardView && {
        option: user.selectedDashboardView.option,
        productManagerId: user.selectedDashboardView.pmId,
      },
      status: user.st,
      supplierAccessLevel: user.supplierAcssLvls as SupplierAccessLevel,
      termsOfService: user.tos && {
        accepted: user.tos.accept,
        acceptedTS: user.tos.acceptTS,
      },
      token,
      userName: user.usrName,
    };
  }
}
